var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenTrkDeSel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6447 4.57782L17.4501 4.56305V1.59958C17.4501 1.15826 17.2713 0.759598 16.9798 0.470305C16.6905 0.178825 16.2918 0 15.8505 0H1.60028C1.11411 0 0.677168 0.21984 0.382953 0.564913C-0.0337589 1.05436 0.000693644 1.52795 0.000693644 2.09559V14.3935C0.000693644 15.2636 0.718183 16.0347 1.60028 16.0347H4.21266C4.45328 16.0347 4.64633 15.8411 4.64633 15.601C4.64633 15.3609 4.45328 15.1679 4.21266 15.1679V15.1701H1.59754C1.18958 15.1701 0.867477 14.79 0.867477 14.3935V2.08301C0.867477 1.7024 0.79365 1.36881 1.08677 1.07951C1.22318 0.943719 1.4078 0.867435 1.60028 0.86733H15.8505C16.0518 0.86733 16.2355 0.950454 16.3679 1.0828C16.4997 1.21514 16.5833 1.39834 16.5833 1.59958V15.1701H13.1424C12.9024 15.1701 12.7088 15.3637 12.7088 15.6037C12.7088 15.8438 12.9024 16.0369 13.1424 16.0369H17.0164C17.2565 16.0369 17.4501 15.8438 17.4501 15.6037V15.111H19.2017C19.3997 10.5999 25.8779 9.97758 26.5368 15.111H27.9598C28.3262 10.7126 26.154 9.00306 22.8504 8.61643C22.6131 7.58394 22.1597 6.62583 21.6479 5.67866C21.0392 4.55266 20.897 4.59805 19.6447 4.57782ZM8.72157 2.38926C9.05954 2.38926 9.39039 2.42754 9.70757 2.49973C10.0341 2.57355 10.3474 2.68402 10.6422 2.82566C10.6739 2.84097 10.6876 2.8798 10.6722 2.91152C10.6673 2.92191 10.6602 2.93011 10.6515 2.93613L10.3157 3.20628L10.0007 3.46823C9.98265 3.48354 9.95859 3.48682 9.93781 3.47916C9.7464 3.40971 9.54625 3.35612 9.34063 3.32003C9.14047 3.28503 8.93321 3.26643 8.72212 3.26643C7.77495 3.26643 6.87535 3.63885 6.20599 4.30876C5.53553 4.97977 5.16311 5.87717 5.16311 6.82544C5.16311 8.26807 6.03427 9.56579 7.36097 10.1148C9.18094 10.869 11.2667 9.98688 12.0115 8.18659C12.19 7.75501 12.2816 7.29247 12.2811 6.82544C12.2811 6.59466 12.2593 6.36826 12.215 6.14186C12.2117 6.12217 12.2171 6.10248 12.2286 6.08826L12.513 5.72296L12.8061 5.3571C12.8133 5.34831 12.8228 5.3416 12.8334 5.33767C12.8441 5.33373 12.8557 5.33272 12.8669 5.33472C12.8781 5.33673 12.8885 5.34168 12.8972 5.34908C12.9058 5.35647 12.9123 5.36604 12.916 5.37679C13.0774 5.84272 13.1583 6.33271 13.1583 6.82544C13.1583 7.4259 13.0385 7.99902 12.822 8.52127C11.8934 10.7645 9.29469 11.8648 7.02629 10.9253C5.37803 10.2434 4.28539 8.6301 4.28539 6.82544C4.28539 5.64585 4.75078 4.52259 5.58475 3.68861C6.41872 2.85464 7.54198 2.38926 8.72157 2.38926ZM8.6215 12.7682C7.00004 12.7682 5.68482 14.0835 5.68482 15.7049C5.68482 17.3264 7.00004 18.6416 8.6215 18.6416C10.243 18.6416 11.5576 17.3264 11.5576 15.7049C11.5554 14.0835 10.243 12.7682 8.6215 12.7682ZM8.6215 14.5762C7.99971 14.5762 7.49222 15.0804 7.49222 15.7049C7.49222 16.3272 7.99698 16.8342 8.6215 16.8342C9.24329 16.8342 9.75078 16.3294 9.75078 15.7049C9.74804 15.0804 9.24329 14.5762 8.6215 14.5762ZM22.8603 12.3362C21.2393 12.3362 19.9241 13.6514 19.9241 15.2729C19.9241 16.8943 21.2393 18.2096 22.8603 18.2096C24.4817 18.2096 25.7969 16.8943 25.7969 15.2729C25.7969 13.6514 24.4817 12.3362 22.8603 12.3362ZM21.7315 15.2729C21.7315 15.8952 22.2357 16.4022 22.8603 16.4022C23.4848 16.4022 23.9895 15.8974 23.9895 15.2729C23.9895 14.6484 23.4848 14.1442 22.8603 14.1442C22.2374 14.1442 21.7315 14.6495 21.7315 15.2729ZM19.8552 5.83124L18.5324 5.80663V8.62135H21.3345C20.9889 7.6173 20.4776 6.69693 19.8552 5.83124Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80362 4.78979H7.81836V6.9622L9.44027 8.58411L10.1361 7.88824L8.80362 6.55572V4.78979Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74993 2.40625C6.30294 2.40625 4.32031 4.39022 4.32031 6.83587C4.32031 9.28151 6.30429 11.2655 8.74993 11.2655C11.1969 11.2655 13.1796 9.28151 13.1796 6.83587C13.1796 4.39022 11.1956 2.40625 8.74993 2.40625ZM8.74993 10.2829C6.84941 10.2829 5.30422 8.73774 5.30422 6.83721C5.30422 4.93669 6.84941 3.39151 8.74993 3.39151C10.6505 3.39151 12.1956 4.93669 12.1956 6.83721C12.1956 8.73774 10.6491 10.2829 8.74993 10.2829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.67969,
    y1: 1.61875,
    x2: 14.7654,
    y2: 1.61875,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.67969,
    y1: 3.09531,
    x2: 4.41402,
    y2: 3.09531,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.0312,
    y1: 3.09531,
    x2: 15.7656,
    y2: 3.09531,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3594,
    y1: 9.76694,
    x2: 15.7656,
    y2: 9.76694,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.67969,
    y1: 9.76694,
    x2: 4.0859,
    y2: 9.76694,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.66895,
    y1: 12.5443,
    x2: 14.7756,
    y2: 12.5443,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.7969,
    y1: 4.4625,
    x2: 15.7656,
    y2: 4.4625,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.0156,
    y1: 8.45444,
    x2: 15.7656,
    y2: 8.45444,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.67969,
    y1: 8.45444,
    x2: 3.42966,
    y2: 8.45444,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.3975,
    y1: 5.74766,
    x2: 15.7657,
    y2: 5.74766,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.67969,
    y1: 5.775,
    x2: 3.04795,
    y2: 5.775,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.67969,
    y1: 7.14219,
    x2: 3.04795,
    y2: 7.14219,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.3984,
    y1: 7.14219,
    x2: 15.7667,
    y2: 7.14219,
    stroke: "black",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.67969,
    y1: 4.4625,
    x2: 3.64841,
    y2: 4.4625,
    stroke: "black",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenTrkDeSel);
export default __webpack_public_path__ + "static/media/penTrkDeSel.c8b26fec2cdac8de6295126aeb94768a.svg";
export { ForwardRef as ReactComponent };